import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson1: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"https://www.unityacademy.io/courses/trading-introduction"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Crypto Introduction
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson2"}>
          <div className="rounded-32xl bg-gainsboro-200 box-border w-[9.81rem] h-[3.5rem] flex flex-col items-end justify-start py-[0.69rem] px-[3rem] border-[1px] border-solid border-gray-200">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="flex flex-col items-center justify-center gap-[5.63rem] w-[92%] mr-[4%] max-w-[110rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[11.19rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What is Cryptocurrency</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cryptocurrency is a digital currency created to work as a
                  medium/intermediary of exchange. It utilizes cryptography to
                  verify and secure transactions.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Most cryptocurrencies are built on blockchain technology,
                  which is basically "a distributed ledger enforced by a
                  distributed network of computers". Cryptocurrencies are unique
                  as opposed to fiat currencies (USD/EURO) because no central
                  authority issues them. This potentially eliminates government
                  intervention and the threat of manipulation.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[27.31rem] h-[23.23rem] object-cover"
            alt=""
            src="/i1@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>What Are The Benefits of Cryptocurrency</b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="font-dm-sans">{`No middlemen/intermediaries : `}</b>
              <span>
                As Cryptocurrencies operate using the blockchain, two parties in
                a transaction can confirm and complete something without working
                through a third party. This saves time as well as the cost of
                paying for an intermediary like a bank.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="font-dm-sans">{`Safe transfer of Assets : `}</b>
              <span>
                Using your chosen Cryptocurrency you are able to transfer
                assets, such as NFTs safely and anonymously.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="font-dm-sans">{`Strong security : `}</b>
              <span>
                Once a cryptocurrency transfer has been authorized, it cannot be
                reversed therefore preventing chargebacks.
              </span>
            </span>
          </p>
        </div>
        <b className="self-stretch relative text-[2.81rem] font-nunito text-center">
          How Does Crypto Currency Work
        </b>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Blockchain Technology</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                A blockchain is a form of distributed leger technology, which is
                essentially a database built out over various operators (nodes,
                computing devices, etc.) It’s a digital ledger that verifies
                accounts, balances, and transactions.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Cryptography</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The word cryptocurrency is derived from the encryption
                techniques which are used to secure the network, "cryptography".
                This guarantees the security of all transactions and its
                participants. It is independent of any central authority. 
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Cryptography and blockchain both help cryptocurrencies create
                new coins, enforce legitimate verifiable transactions, and
                create a secure system.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Decentralization</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Decentralized means that all authoritative power is spread
                across all peers on a network, and no single point of failure
                exists. 
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To "hack" Bitcoin, for example, someone would have to conduct a
                51% attack on the vast network of computers running Bitcoin,
                which is seen as an impossible task.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Peer to Peer</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Cryptocurrency can be sent directly between two people
                eliminating the need for a broker. These transactions have very
                minimal processing fees that go toward compensating the network.
                This allows users to avoid the high transaction fees associated
                with more typical payment transfer services (Paypal, Zelle,
                Banks, etc)
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What Gives A Cryptocurrency Value?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Since cryptocurrencies are entirely digital they do not exist as
                a stack of notes or coins. Instead, they live only on the
                internet. Think of them as virtual tokens, whose value is
                determined by certain market forces created by individuals who
                want to buy or sell them.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Unlike stocks, real estate, precious metals, etc.,
                cryptocurrencies have little to no inherent value outside of
                possession.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Here are three main things that can give a cryptocurrency value:
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Coin Utility</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Each coin is deemed to have a utility upon it's creation,
                  demonstrated through their whitepaper.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Every coin has a “whitepaper” where all the information about
                  it is stored. A whitepaper sheds light on two major aspects of
                  a crypto project – its purpose and the technology behind it. A
                  bit like a manifesto.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Scarcity / Demand</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Scarcity - A variable factor, but each coin has a different
                  figure of supply available. As it's not unlimited, increasing
                  demand raises the price.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Let's use Bitcoin as an example. Its inventor Satoshi Nakamoto
                  capped the total number of bitcoins at 21 Million.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Adoption (Demand) - The more the coin becomes adopted, the
                  higher it's use case and the ecosystem grows. A clear case of
                  this is shown through El Salvador making Bitcoin Legal Tender.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Perceived Value</span>
            </b>
          </p>
          <p className="m-0">
            <span className="text-gainsboro-100">
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span className="text-gainsboro-100">
                <span className="text-[1.4rem] font-dm-sans">
                  Perception - Investors basing decisions off of milestones and
                  data points. The more investment in the project, the price
                  rises!
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span className="text-gainsboro-100">
                <span className="text-[1.4rem] font-dm-sans">
                  Inherent value depends on the overall viability and progress
                  of the crypto project development. Those that keep developing,
                  achieving one milestone after another, establishing lucrative
                  partnerships or launching user-friendly software becomes more
                  valuable in the eyes of the market. All of these indicators
                  contribute to positive "perception" affecting the value of the
                  cryptocurrency.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span className="text-gainsboro-100">
                <span className="text-[1.4rem] font-dm-sans">
                  Value can be perceived by a coin's market cap ****which is a
                  straightforward indicator of the coin’s value on the market
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span className="text-gainsboro-100">
                <span className="text-[1.4rem] font-dm-sans">
                  Market Cap = Total Circulating Supply * Price of each coin.
                </span>
              </span>
            </li>
            <li>
              <span className="text-gainsboro-100">
                <span className="text-[1.4rem] font-dm-sans">{`The values of Cryptocurrencies can be viewed on sites such as `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://coinmarketcap.com/"
                target="_blank"
              >
                <span className="text-gainsboro-100">
                  <span className="text-[1.4rem] font-dm-sans">
                    <span className="[text-decoration:underline]">
                      CoinMarketCap
                    </span>
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </div>
        <div className="self-stretch h-[5.13rem] flex flex-col items-center justify-start text-center text-[2.81rem] font-nunito">
          <b className="self-stretch relative">
            Different Types Of Cryptocurrencies
          </b>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Tokens</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Tokens are created on top of an existing blockchain and can be
                  used as part of a software application (like to grant access
                  to an app, to verify identity, or to track products moving
                  through a supply chain), or they can even represent digital
                  art (like with NFTs that certify something as unique).
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Tokens represent a project's asset or utility that is sold (or
                  given) during the project's first public sale, known as an
                  Initial Coin Offering
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Tether is an example of a token, a stable coin (Explained
                  below) backed by commercial paper, makes use of more than one
                  blockchain to gain speed and reduce user costs. So, unlike
                  coins, tokens can choose to not be ‘bound’ to a single
                  blockchain, gaining flexibility and becoming easier to trade.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Coins</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  The main products within the crypto market are the individual
                  coins. A digital coin is created on its own blockchain and
                  acts in basically the same way as traditional money. It can be
                  used to store value and act as a means of direct exchange
                  between two parties doing business with each other. They can
                  be split into various categories:
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>{`Bitcoin & Ethereum`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  The two main cryptocurrencies in a class of their own. Leading
                  the entire market in total market cap (total market value of
                  cryptocurrency's circulating supply).
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Altcoins</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  "Altcoins" refers to all cryptocurrencies other than Bitcoin
                  and Ethereum. As of October 2021, altcoins accounted for
                  nearly 60% of the total cryptocurrency market, with more than
                  12,000 cryptocurrencies and counting. For the most part, the
                  altcoin market is mainly driven by speculation. There are
                  several cases of dead cryptocurrencies, those that failed to
                  gain enough traction or "rugged" (vanished) after collecting
                  crypto investors' money. It is important for all crypto
                  investors to be aware of the risks associated of an
                  unregulated volatile market.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                <span>Types of Altcoins</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>
                <span className="text-[1.81rem]">Meme Coins</span>
              </b>
              <span> - DogeCoin, Shubuya.</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                These serve little to no purpose as they lack utility and
                function, but are constantly pumped and dumped (Rise and Fall),
                providing opportunities for large profits.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.81rem] font-dm-sans">Stable Coins</b>
              <span>
                {" "}
                - Cryptocurrencies are known for volatility. Stable coins aim to
                reduce overall volatility by pegging their value to a basket of
                goods, such as fiat currencies, precious metals, or other
                cryptocurrencies. The basket is meant to act as a reserve to
                redeem holders if the cryptocurrency fails or faces problems.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.81rem] font-dm-sans">Mining Based Coins</b>
              <span>
                {" "}
                - As the name suggests these coins are mined into existence,
                Most use a method called Proof Of Work (POW) where systems
                generate new coins by solving difficult problems, to create
                blocks. Some examples of notable ones are Litecoin, Monero and
                Zcash.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch h-[2.06rem] flex flex-row items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="flex-1 relative">Legality and Regulations</b>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] font-medium text-gainsboro-100">
          <p className="m-0">
            With the rise of cryptocurrencies over the last decade, there has
            been an equal rise in the interest for regulation on a global scale.
            The United States has expanded its monitoring of the crypto industry
            over time. Following the ICO frenzy of 2017 and 2018, the Securities
            and Exchange Commission (SEC) took action against initial coin
            offerings, or ICOs. Other US authorities, such as the Commodity
            Futures Trading Commission (CFTC), have also been involved in a
            number of ways.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Similarly, crypto regulation outside of the United States has also
            evolved over time in response to changing regulatory guidelines. The
            European Union's fifth Anti-Money Laundering Directive, for example,
            specifies that crypto purchasing, selling, and other operations in
            particular countries must follow certain guidelines.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            As a secured member learning the fundamentals of cryptocurrency,
            it's vital to keep in mind that the global regulatory environment
            surrounding cryptocurrencies is constantly changing. Things can even
            change tomorrow! There are still plenty of big important global
            decisions yet to come regarding cryptocurrencies.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="flex-1 relative inline-block h-[2.81rem]">
            Benefits and Risks
          </b>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Advantages of Crypto:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>"Quick and secure transactions</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>All transactions are recorded in a public ledger</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Eliminates intermediaries lowering total transaction costs
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Universal Accessibility</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Public and Private Keys safeguard transactions</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Plenty of options to secure your cryptocurrencies (Cold/Hot
                  Wallets)
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Increasing global acceptance and recognition</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Form of payment acceptance</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Can serve as protection from currency debasement and inflation
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Disadvantages of Crypto:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>High Volatility</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Unstable Value in Nature</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Complex and Intricate</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Unregulated and Decentralized</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>No customer service support</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>No asset protection or insurance</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Target for malicious scams</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Prone to phishing and cyber hacks</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Home for various illegal activities</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Irreversibility</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Once transactions are complete there is no way back</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Immense emphasis on personal responsibility of security
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Loss of private keys can lead to loss of crypto assets
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>Lack of proper security measures can lead to hacks</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="flex-1 relative">Outlook For Cryptocurrency</b>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            Cryptocurrency has made great strides in the past decade,
            progressing at incredible speeds. Value can be stored, exchanged,
            and spent in a variety of ways using a range of assets and
            solutions. Defi has also opened the way for new borrowing and
            lending opportunities.
          </p>
          <p className="m-0">
            Some big mainstream businesses are interested in blockchain
            technology. They are slowly beginning to explore a variety of
            blockchain tech applications such as supply chain management. There
            is still plenty of ways to go for cryptocurrency to become
            mainstream but the future of cryptocurrency and its accompanying
            technology appears bright.
          </p>
          <p className="m-0">
            For now, remember that beginning to understand cryptocurrency
            fundamentals will help you to be aware of the ongoing cryptocurrency
            conversation that’s slowly becoming more frequent globally.
          </p>
          <p className="m-0">
            Please take a look at the resources below for more in-depth
            information on the fundamentals of the cryptocurrency market.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="flex-1 relative">{`Where Can You Buy & Sell Cryptocurrency?`}</b>
        </div>
        <div className="self-stretch flex flex-col items-center justify-center text-[1.56rem] text-gainsboro-100">
          <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
            {`In order to buy and sell Cryptocurrency, you must sign up to an `}
            <a
              className="text-[inherit]"
              href="https://www.notion.so/3508323846cb4b04a2aa8373db6f8e5f?pvs=21"
              target="_blank"
            >
              <span className="[text-decoration:underline]">exchange</span>
            </a>{" "}
            such as Binance or Coinbase. This means you can purchase
            Cryptocurrency using your normal currency e.g. USD, EUR, GBP (Fiat
            money) which can later be used for your NFT transactions.
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Buying Crypto</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Once you have signed up and deposited money into your account,
                you can convert your fiat currency into crypto. E.G converting
                USD into Bitcoin within the "Trade" section of the exchange.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you have purchased your crypto, it will appear in your
                balance, shown through your Assets or Portfolio section. You are
                now the proud owner of your chosen digital currency!
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Selling Crypto</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If you want to sell your crypto you can head back to the trade
                section of your exchange and sell it back for your chosen fiat
                currency. Such as selling Bitcoin (BTC) back into USD. You can
                then withdraw this money back into your bank.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[4.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Wallets</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Cryptocurrency wallets store a users public and private keys
                  while also providing an interface to manage crypto balances
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  This is where all of your crypto can be stored, managed,
                  transferred, sent to other wallets etc. Each wallet is given
                  its own wallet address as well as a seed phrase
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A wallet address is a randomly generated set of numbers and
                  letters that work like a sort code or bank account number.
                  This is the address you use to transfer crypto. Each
                  cryptocurrency has its own wallet address. So sending ethereum
                  to a wallet and sending bitcoin to a wallet would require a
                  different address.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[33.13rem] h-[30.13rem] object-cover"
            alt=""
            src="/i2@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            A seed phrase is your password. It is a cluster of random words
            generated by your crypto wallet when setting it up, which can be
            used as an emergency backup if you ever need to restore access to
            your funds.
          </p>
          <p className="m-0">Here’s an example of an Ethereum Address:</p>
          <p className="m-0">0xb794f5ea0ba39494ce839613fffba74279579268.</p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[9.69rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Wallets - Hot vs Cold</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  There's 2 types of wallets, hot and cold. A hot wallet is a
                  wallet that is always connected to the internet. Hot wallets
                  are used to send and receive cryptocurrency, and they allow
                  you to view how many tokens you have available to use.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Because hot wallets are connected to the internet, they tend
                  to be somewhat more vulnerable to hacks and theft than cold
                  storage methods.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A cold wallet is used offline for storing cryptocurrencies.
                  With a cold wallet, also originally known as cold storage, the
                  digital wallet is stored on a platform not connected to the
                  internet, thereby protecting the wallet from unauthorized
                  access, cyber hacks, and other vulnerabilities that a system
                  connected to the internet is susceptible to.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[28.31rem] h-[33.14rem] object-cover"
            alt=""
            src="/i3@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          So you’ll find that majority of crypto investors use cold storages.
          Therefore their crypto is safe from hacks and corruptions from
          exchanges
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.4rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Exchanges</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Exchanges work similarly to a broker, giving you the tools to
                  buy and sell cryptocurrencies like Bitcoin, Ethereum, and
                  Tether. If you want to buy or sell cryptocurrencies, opening
                  an account with a cryptocurrency exchange is a great way to
                  start. Crypto exchanges function similarly to online brokerage
                  platforms, providing you with the tools you need to buy and
                  sell digital currencies and tokens.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  When choosing a cryptocurrency exchange, it’s important to
                  look at factors such as supported assets, fees, payment
                  methods, and security.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  {`Each exchange has different features, limits, regulations etc. Some of the top ones are binance, coinbase, `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="http://crypto.com"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      crypto.com
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span> and many more</span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Most exchanges require you to be over the age of 18 to trade
                  however bybit is non kyc. This means you don't need to submit
                  any ID Verification. However you will not be able to withdraw
                  any funds you make until you're 18. This is still extremely
                  good as it allows you to deposit money, practice, make money.
                  Think of it as a huge 18th bday present
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  In crypto, there's a fee every time you make a transaction.
                  These are called many names: gas fee, transaction fee,
                  blockchain fee.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The fee is collected in order to process the transaction on
                  the blockchain
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  You need to pay the blockchain fee to ensure your
                  cryptocurrency transfers arrive in a timely manner. The
                  blockchain fee is one of the main tools used to speed up
                  crypto transactions, which are often slow due to high
                  congestion on the blockchain network. The lower the blockchain
                  fee, the lower your transaction's priority in the blockchain
                  network.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Miner Fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Transaction or miner fees are designed to incentivize miners
                  and validators to confirm cryptocurrency transactions, and
                  typically fluctuate depending how many transactions are
                  waiting to be added to the current block.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Service fees</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Service or network fees are charged by third-party service
                  providers that facilitate transactions, such as a Bitcoin ATM
                  or buy crypto on an exchange. These fees are charged over and
                  above any network-originated fees paid to miners.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-center text-[2.81rem] font-nunito">
          <b className="flex-1 relative inline-block h-[2.81rem]">
            Decentralisation
          </b>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            A good or service is decentralized if it is run by a collective of
            participants using majority rule. In the case of bitcoin, its
            attributes, such as the total supply of bitcoins, are determined by
            the majority of its network participants.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Understanding decentralization and its importance is imperative to
            understanding cryptocurrency in general and why it was created in
            the first place.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Outside of the internet, which is partially centralized due to
            internet service providers, bitcoin is the first real example of a
            system with no central authority.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            So rather than data being stored and controlled from 1 main
            organisation. Instead data is controlled from a network of computers
            so no 1 entity has control over it
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.4rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Blockchain</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A blockchain is a distributed database or ledger that is
                  shared among the nodes of a computer network.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Think of it as a list of transactions that anyone can view and
                  verify. The Bitcoin blockchain, for example, contains a record
                  of every time someone sent or received bitcoin.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Almost all cryptocurrencies, including `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/price/bitcoin"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Bitcoin</span>
                  </span>
                </span>
              </a>
              <span>
                <span>{`, `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/price/ethereum"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Ethereum
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>{`, `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/price/bitcoin-cash"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Bitcoin Cash
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>{`, and `}</span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coinbase.com/price/litecoin"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      Litecoin
                    </span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  , are secured via blockchain networks. Which means their
                  accuracy is constantly being verified by a huge amount of
                  computing power.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Imagine a global, open alternative to every financial service
                  you use today, accessible with little more than a smartphone
                  and internet connection.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  The list of transactions contained in the blockchain is
                  fundamental for most cryptocurrencies because it enables
                  secure payments to be made between people who don’t know each
                  other without having to go through a third-party verifier like
                  a bank.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Smart Contracts</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A smart contract, like any contract, establishes the terms of
                  an agreement. But unlike a traditional contract, a smart
                  contract’s terms are executed as code running on a blockchain
                  like Ethereum. Smart contracts allow developers to build apps
                  that take advantage of blockchain security, reliability, and
                  accessibility while offering sophisticated peer-to-peer
                  functionality everything from loans and insurance to logistics
                  and gaming.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Smart contracts allow developers to build a wide variety of
                  decentralized apps and tokens. They’re used in everything from
                  new financial tools to logistics and game experiences, and
                  they’re stored on a blockchain like any other crypto
                  transaction. Once a smart-contract app has been added to the
                  blockchain, it generally can’t be reversed or changed
                  (although there are some exceptions).
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Some of the more popular current smart-contract powered
                  applications include:
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>Uniswap, Compound and USDC</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[5.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Whitepaper</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    A whitepaper is a document released by developers that
                    explains the technology and purpose of the project they are
                    working on. It tells investors how the cryptocurrency was
                    conceived and highlights its purpose. A crypto whitepaper
                    contains various forms of data like statistics, diagrams,
                    and formulas.
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    Crypto whitepapers are packed full of information and are
                    often around 25 pages long. But what do they typically
                    include?
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[33.13rem] h-[25.04rem] object-cover"
            alt=""
            src="/i4@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            The problem and solution, Token information and marketplace
            consideration, Technical description, Project timeline, Team and
            advisors
          </p>
          <p className="m-0">
            Whitepapers are a staple in crypto, but they’ve actually been around
            for much longer. The very first whitepaper originated from the
            British government around 100 years ago, and was created to inform
            the public about key decisions made by government agencies.
          </p>
          <p className="m-0">
            It is essential for crypto start-ups to have a published whitepaper,
            as it is a key element that determines a project’s legitimacy.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Market Cap</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Market Cap = Current Price x Circulating Supply</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Within the blockchain industry, the term market capitalization
                  (or market cap) refers to a metric that measures the relative
                  size of a cryptocurrency. It is calculated by multiplying the
                  current market price of a particular coin or token with the
                  total number of coins in circulation.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  For example, if each unit of a cryptocurrency is being traded
                  at $10.00, and the circulating supply is equal to 50,000,000
                  coins, the market capitalization for this cryptocurrency would
                  be $500,000,000.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  While the market cap may offer some insights about the size
                  and performance of a company or cryptocurrency project, it is
                  important to note that it is not the same as money inflow. So,
                  it does not represent how much money is in the market. This is
                  a common misconception because the calculation of market cap
                  is directly dependent on price, but in fact, a relatively
                  small variation in price may affect the market cap
                  significantly.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.4rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Supply</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Cryptocurrency circulating supply is equivalent to outstanding
                  shares of a publicly traded company. This metric counts the
                  number of coins available for trade, as opposed to the number
                  of maximum coin supply. The circulating supply helps us
                  calculate the market capitalization of every coin.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  {`The circulating supply of a cryptocurrency can increase or decrease over time. For example, the circulating supply of Bitcoin will gradually increase until the max supply of 21 million coins is reached. Such a gradual increase is related to the process of `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://academy.binance.com/en/glossary/mining"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">mining</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {` that generates new coins every 10 minutes, on average. Alternatively, coin burn events like the ones performed by `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.binance.com/en"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">Binance</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  , cause a decrease in the circulating supply, permanently
                  removing coins from the market.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  {`The total supply doesn’t include coins that have been `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coindesk.com/learn/what-does-it-mean-to-burn-crypto/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">burned</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  . This refers to tokens that have been permanently removed
                  from circulation by being sent to a wallet to which nobody has
                  the key.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.4rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">Burn</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  {`Burning crypto means permanently removing a number of tokens from circulation. This is typically done by transferring the tokens in question to a burn address, i.e. a `}
                </span>
              </span>
              <a
                className="text-[inherit]"
                href="https://www.coindesk.com/learn/your-first-crypto-wallet-how-to-use-it-and-why-you-need-one/"
                target="_blank"
              >
                <span>
                  <span>
                    <span className="[text-decoration:underline]">wallet</span>
                  </span>
                </span>
              </a>
              <span>
                <span>
                  {" "}
                  from which they cannot ever be retrieved. This is often
                  described as destroying tokens.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  A project burns its tokens to reduce the overall supply. In
                  other words, it creates a "deflationary" event. The motivation
                  is often to increase the value of the remaining tokens since
                  assets tend to rise in price whenever the circulating supply
                  falls and they become more scarce.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Burning tokens can be similar to a company buying back its
                  shares. The company “returns the value” to its shareholders in
                  this way. Crypto projects burn their tokens to achieve the
                  same goal.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Burning tokens can also benefit those staking tokens to
                  validate transactions in a proof-of-stake protocol. When a
                  large chunk of tokens are removed from circulation, there’s a
                  likely chance they’ll receive a higher U.S. dollar value from
                  their staking rewards.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Web3</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  At a very basic level, Web3 is the third stage of internet
                  development where individuals will have more control over the
                  web.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  To understand exactly what Web3 is, you need to have a basic
                  understanding of the first two stages.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The first stage of the internet, Web1, mostly involved users
                  reading static webpages, although forums and message boards
                  did exist.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  The next stage, Web2, marked the arrival of social media like
                  Facebook and Twitter, and sites based around user-generated
                  content like YouTube
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  The basic idea behind Web3 is that individuals will exercise
                  more control of the internet: It will represent a transition
                  from big companies controlling and monetizing content on the
                  internet to individual creators and consumers sharing content
                  and interacting through decentralized networks. These networks
                  would rely on open protocols, allowing anyone to connect and
                  participate, and shift power away from big companies and
                  toward creators and users.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Pump n Dumps</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A crypto pump signal is a message intended to entice
                  individuals to purchase a cryptocurrency so they can profit
                  from the price manipulation caused by the sudden uptick in
                  demand. After the pumping causes a significant price hike,
                  which are called crypto dump signals, members start selling at
                  a good profit. There are two types of groups on Telegram and
                  Discord that post signals on unknown crypto coins to inflate
                  the value of the underlying coins artificially
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Pump and Dumps aren't as popular anymore however back in
                  2020-2021 they were everywhere, seeing % gains upwards of
                  1,000% in a few minutes. Some groups had 50,000+ members
                  between Discord and Telegram
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  The more members the better, this meant more volume being
                  pumped into the coin. However don't forget the main objective
                  of the a pump: for the owners of the group to make money.
                  Before they announce the coin, the owners will buy thousands
                  of $ worth of the coin so then when it pumps, they dump their
                  money and the price starts crashing
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[2.75rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Staking</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    Like a lot of things in crypto, staking can be a complicated
                    idea or a simple one depending on how many levels of
                    understanding you want to unlock. For a lot of traders and
                    investors, knowing that staking is a way of earning rewards
                    for holding certain cryptocurrencies is the key takeaway.
                    But even if you’re just looking to earn some staking
                    rewards, it’s useful to understand at least a little bit
                    about how and why it works the way it does.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[58.25rem] h-[31.63rem] object-cover"
            alt=""
            src="/i5@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            If a cryptocurrency you own allows staking you can stake some of
            your holdings and earn a percentage rate reward over time. This
            usually happens via a staking pool which you can think of as being
            similar to an interest-bearing savings account.
          </p>
          <p className="m-0">
            The reason your crypto earns rewards while staked is because the
            blockchain puts it to work. Cryptocurrencies that allow staking use
            a “consensus mechanism” called Proof of Stake, which is the way they
            ensure that all transactions are verified and secured without a bank
            or payment processor in the middle. Your crypto, if you choose to
            stake it, becomes part of that process.
          </p>
          <p className="m-0">
            Staking often requires a lockup or “vesting” period, where your
            crypto can’t be transferred for a certain period of time. This can
            be a drawback, as you won’t be able to trade staked tokens during
            this period even if prices shift.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[2.75rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Mining</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    Mining is the process that Bitcoin and several other
                    cryptocurrencies use to generate new coins and verify new
                    transactions. It involves vast, decentralized networks of
                    computers around the world that verify and secure
                    blockchains. The virtual ledgers that document
                    cryptocurrency transactions. In return for contributing
                    their processing power, computers on the network are
                    rewarded with new coins.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[58.25rem] h-[31.63rem] object-cover"
            alt=""
            src="/i6@2x.png"
          />
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            There are three primary ways of obtaining bitcoin and other
            cryptocurrencies. You can buy them on an exchange like Coinbase,
            receive them as payment for goods or services, or virtually “mine”
            them. It’s the third category that we’re explaining here, using
            Bitcoin as our example.
          </p>
          <p className="m-0">
            You might have considered trying bitcoin mining yourself. A decade
            ago, anyone with a decent home computer could participate. But as
            the blockchain has grown, the computational power required to
            maintain it has increased. (By a lot: In October 2019, it required
            12 trillion times more computing power to mine one bitcoin than it
            did when the first first blocks were mined in January 2009.) As a
            result, amateur bitcoin mining is unlikely to be profitable for
            hobbyists these days. Virtually all mining is now done by
            specialized companies or groups of people who band their resources
            together. But it’s still good to know how it works.
          </p>
        </div>
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          Investors may also follow the crowd and invest due to social media or
          news articles.
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            <b>Market Sentiment</b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                One of the main factors that drive any asset’s value is market
                sentiment.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Attitudes towards cryptocurrencies can help drive the price of
                individual coins and the wider market.
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                Sentiment can be influenced by a cryptocurrency’s actual
                fundamentals.
              </span>
            </li>
            <li>
              <span>
                Investors have been attracted to Bitcoin and Ethereum as they
                were the first to offer decentralised ways of transferring money
                and have established technology that helps store and track
                transactions.
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>News Development</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Investors rely on news stories as a way to monitor the
                  cryptocurrency market.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  A positive story can boost cryptocurrency pricing due to a
                  boost in market sentiment.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This can increase demand in the crypto markets, helping push
                  up prices.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  However, bad news can make investors panic and try to sell
                  their cryptos if they are worried about the impact on their
                  portfolio.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>This can push cryptocurrency prices down.</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Crypto Adoption</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Adoption can help drive up values as it helps move them into
                  the mainstream and gives the cryptocurrency industry
                  credibility.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  That includes shops accepting cryptocurrencies as forms of
                  payments or apps letting you buy and sell virtual currencies
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Mass adoption can have a significant impact and many investors
                  rely on this as a good indicator of cryptocurrency values.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Two indicators of adoption last year included PayPal letting
                  users buy and sell digital currency and El Salvador
                  recognising Bitcoin as legal tender.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  Political events could also push prices down such as if
                  governments ban or publicly oppose the use of
                  cryptocurrencies.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Regulation Of Crypto</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  There is currently no consistent global regulation of the
                  cryptocurrency sector.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  One reason for this is that the crypto industry isn’t based in
                  one place so it is up to national authorities such as
                  financial regulators and central banks to set their own rules
                  about digital cash.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Some countries have gone as far as banning Bitcoin and other
                  cryptocurrencies as they are worried about price risks and
                  criminal use.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Others, such as the Financial Conduct Authority (FCA) in the
                  UK are in the process of introducing rules to ensure retail
                  investors understand the risks of cryptocurrencies such as
                  price volatility before investing.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Regulation can be a way of giving cryptocurrencies legitimacy
                  as exchanges, where you can trade cryptocurrency, have to
                  conduct due diligence on coins to ensure they are genuine and
                  aren’t scams.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  This can help push the price up as investors may be reassured
                  that a certain cryptocurrency has a bright future.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  But prices can fall across crypto markets if regulation goes
                  as far as banning Bitcoin or other cryptocurrencies, as
                  countries such as China and India have done
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>DAO’s</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1.4rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  A decentralized autonomous organization (DAO) is an emerging
                  form of legal structure that has no central governing body and
                  whose members share a common goal to act in the best interest
                  of the entity. Popularized through cryptocurrency enthusiasts
                  and blockchain technology, DAOs are used to make decisions in
                  a bottoms-up management approach.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  One of the major features of digital currencies is that they
                  are decentralized. This means they are not controlled by a
                  single institution like a government or central bank, but
                  instead are divided among a variety of computers, networks,
                  and nodes. In many cases, virtual currencies make use of this
                  decentralized status to attain levels of privacy and security
                  that are typically unavailable to standard currencies and
                  their transactions.
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  Inspired by the decentralization of cryptocurrencies, a group
                  of developers came up with the idea for a decentralized
                  autonomous organization, or DAO, in 2016.
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  The concept of a DAO is to promote oversight and management of
                  an entity similar to a corporation. However, the key to a DAO
                  is the lack of central authority; the collective group of
                  leaders and participants act as the governing body.
                </span>
              </span>
            </li>
          </ul>
        </div>
        <a className="w-full mb-[6rem] rounded-32xl bg-gainsboro-200 box-border flex flex-row items-center justify-between py-[0.75rem] px-[0rem] max-w-[25rem] text-center text-[2.81rem] border-[1px] border-solid border-gray-300" 
      href="/lesson2">
        <div className="w-full">
            <b className="inline-block flex-1 w-full relative text-center max-md:pb-[1.3rem]">Next Chapter</b>
          </div>
          </a>
        </div>
    </div >
  );  
};  

export default Lesson1;
